import Icon from '../../../../../common/Icon/Icon'

import type {Props} from './LogMessageRunningIcon.types'

function LogMessageRunningIcon({runningIcon}: Props) {
  return runningIcon != null ? <Icon name={runningIcon} /> : null
}

export default LogMessageRunningIcon
